export default class FiltersStore {

    constructor(filterType) {
        this.filterType = filterType;
        this.filters = {};
        this.selectCount = 0;
    }

    updateAvailableFilters(filters) {
        this.disableAllFilters();
        filters.forEach(
            (filter) => {
                let prevSelected = Boolean(this.filters[filter] && this.filters[filter].selected);
                this.filters[filter] = {
                    name: filter,
                    selected: prevSelected,
                    available: true,
                }
            }
        );
    }

    disableAllFilters() {
        Object.keys(this.filters).forEach(
            (filterKey) => {
                this.filters[filterKey].available = false;
            }
        )
    }

    __toggleAllFilters(selected) {
        Object.keys(this.filters).forEach(
            (filterKey) => {
                this.filters[filterKey].selected = selected;
            }
        )
    }

    clearAllFilters() {
        this.__toggleAllFilters(false);
        this.selectCount = 0;
    }

    selectAllFilters() {
        this.__toggleAllFilters(true);
        this.selectCount = this.filters.length;
    }

    selectFilters(filters) {
        this.clearAllFilters();
        filters.forEach(
            (filter) => {
                this.filters[filter] = {
                    name: filter,
                    selected: true,
                    available: true
                }
              this.selectCount++;
            }
        );
    }

    getAppliedFilters() {
       let appliedFilters = [];
        Object.keys(this.filters).forEach(
           (filterKey) => {
               if (this.filters[filterKey].selected && this.filters[filterKey].available) {
                   appliedFilters.push(filterKey);
               }
           }
       );
        return appliedFilters;
    }

    getAvailableFilters() {
        let availableFilters = [];
        Object.keys(this.filters).forEach(
            (filterKey) => {
                if (this.filters[filterKey].available) {
                    availableFilters.push(this.filters[filterKey]);
                }
            }
        );
        return availableFilters;
    }
    
    getSelectCount() {
      return this.selectCount;
    }
    getSingleSelection() {
      return this.selectCount===1;
    }
}
